import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../../pages/Home';
import Wrapper from '../wrapper/Wrapper';
import Blogs from '../Blogs';
import BlogDetail from '../Blogs/BlogDetail';
import ServiceDetail from '../../pages/ServiceDetail';
import NotFound from '../../pages/NotFound';
import services from '../../data/services';

export default function AppRoutes() {
  return <Routes>
    <Route path="/" element={<Wrapper />}>
      <Route index element={<Home />} />
      <Route path="blogg" element={<Blogs />} />
      <Route path="blogg/:slug" element={<BlogDetail />} />
      {services.map(service => <Route key={service.path} path={service.path} element={<ServiceDetail />} />)}
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>;
}
